export default __webpack_public_path__ + "static/media/t4e.2e10b313.png";